/**
 * Parse flexible time input into minutes.
 * Accepts: "1.5" or "1,5" (hours, Swedish decimal comma), "1:30" (h:mm),
 * "1h30m", "1h30", "90m", "1h"
 * Returns: minutes as integer, or null if invalid.
 */
export const parseTimeInputMinutes = (input) => {
  if (!input && input !== 0) return null;
  const str = String(input).trim();
  if (!str) return null;
  // "1:30" → 90 min (validates minutes 0-59)
  const colonMatch = str.match(/^(\d+):(\d{1,2})$/);
  if (colonMatch) {
    const mins = parseInt(colonMatch[2]);
    if (mins > 59) return null;
    return parseInt(colonMatch[1]) * 60 + mins;
  }
  // "1h30m", "1h30", "1h", "30m"
  const hmMatch = str.match(/^(?:(\d+)h(?:(\d+)m?)?|(\d+)m)$/i);
  if (hmMatch) {
    if (hmMatch[3]) return parseInt(hmMatch[3]);
    return (parseInt(hmMatch[1]) * 60) + parseInt(hmMatch[2] || 0);
  }
  // plain number → hours to minutes; accept both "." and Swedish ","
  const num = parseFloat(str.replace(',', '.'));
  if (!isNaN(num) && num >= 0) return Math.round(num * 60);
  return null;
};

/**
 * Parse flexible time input into hours (decimal).
 * Same formats as parseTimeInputMinutes but returns hours.
 */
export const parseTimeInputHours = (input) => {
  const mins = parseTimeInputMinutes(input);
  if (mins === null) return NaN;
  return mins / 60;
};
